export default __webpack_public_path__ + "static/media/vipin-profile.DuiYA9Ca.0da25dda.png";